import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { CategoriesService } from '../shared/category/categories.service';
import { Process } from '../shared';
import * as fromUserSetting from '.';
import { processResolver } from '../efaact-routing/process-resolver';

const log = new LoggingService();

export const UserSettingRoute: Ng2StateDeclaration = {
    name: 'usersetting',
    url: '/usersetting',
    data: { requiresAuth: true },
    params: { process: {} },
    resolve: [
        {
            token: 'process',
            deps: [Transition, CategoriesService],
            resolveFn: processResolver
        }
    ],
    component: fromUserSetting.UserSettingFeatureComponent
};
